import React from 'react';
import { motion } from 'framer-motion';
import { Lock } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto" data-id="element-97">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="bg-gradient-to-b from-[#0f1d36] to-[#0a1628] border border-[#1a2b4c] rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-98">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1 bg-gradient-to-r from-transparent via-[#d4af37] to-transparent" data-id="element-99" />

        <div className="inline-flex items-center justify-center p-4 bg-[#d4af37]/10 rounded-full mb-6" data-id="element-100">
          <Lock className="w-10 h-10 text-[#d4af37]" data-id="element-101" />
        </div>

        <h2 className="text-3xl md:text-4xl font-bold text-white font-heading mb-4 tracking-wider" data-id="element-102">
          GARANTÍA 7 DÍAS
        </h2>

        <h3 className="text-xl md:text-2xl text-gold-gradient font-bold mb-8" data-id="element-103">
          Devolución del 100% sin preguntas.
        </h3>

        <div className="space-y-4 text-lg text-[#e2e8f0] font-light" data-id="element-104">
          <p data-id="element-105">Sea cual sea la opción que elijas,</p>
          <p data-id="element-106">estás completamente protegido/a.</p>
          <p data-id="element-107">Si en 7 días sentís que el sistema</p>
          <p data-id="element-108">no cambió tu forma de trabajar,</p>
          <p data-id="element-109">te devolvemos todo.</p>
        </div>

        <div className="mt-8 pt-8 border-t border-[#1a2b4c] flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 text-[#a0aec0] font-medium" data-id="element-110">
          <span data-id="element-111">Sin formularios.</span>
          <span className="hidden md:block" data-id="element-112">•</span>
          <span data-id="element-113">Sin explicaciones.</span>
          <span className="hidden md:block" data-id="element-114">•</span>
          <span data-id="element-115">Sin vueltas.</span>
        </div>
      </motion.div>
    </section>;
}